/**
 * The speeds anything in the app plays back at, and how each one is labelled.
 *
 * There were two `SPEED_OPTIONS`, same name, different files, different ladders: the sound player
 * offered six steps and DataViz's sonification four. Nobody chose that — DataViz's was the smaller
 * of two independently-written lists, and the six-step set already contains all four of its values,
 * so nothing is lost by keeping the finer one. Following a data trend by ear is if anything the
 * case that wants 0.75 and 1.25 most.
 *
 * The LABEL is here too, and that is the half that matters more. Both files derived it the same way
 * and could have stopped agreeing at any point, which is the drift `invariants.test.ts` check 1
 * exists to catch — and the same reason one accessible name now covers both controls.
 */
export const PLAYBACK_SPEEDS = [0.5, 0.75, 1, 1.25, 1.5, 2] as const;

/** As `SelectField` options: the value a `<select>` round-trips, and the multiplier a reader says. */
export function playbackSpeedOptions(): { value: string; label: string }[] {
  return PLAYBACK_SPEEDS.map((speed) => ({ value: String(speed), label: `${speed}x` }));
}
